import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";

type SaleStatusOption = {
  sale_status: number;
  name: string;
};

const saleStatusOptions: SaleStatusOption[] = [
  { sale_status: 0, name: "休業中" },
  { sale_status: 1, name: "営業中" },
  { sale_status: 2, name: "未設定" },
  { sale_status: 9, name: "設定しない" },
];

type SaleStatusSelectProps = {
  changedValue: (value: number | undefined) => void;
  inputValue: number;
};

export default function SaleStatusSelect({
  changedValue,
  inputValue,
}: SaleStatusSelectProps) {
  const initialValue = saleStatusOptions.find(
    (element) => element.sale_status === parseInt(String(inputValue), 10)
  );
  const [value, setValue] = useState<SaleStatusOption | undefined>(
    initialValue
  );

  useEffect(() => {
    if (inputValue !== undefined && inputValue !== null) {
      const newValue = saleStatusOptions.find(
        (item) => item.sale_status === inputValue
      );
      setValue(newValue);
    }
  }, [inputValue]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: SaleStatusOption | null
  ) => {
    setValue(newValues ?? undefined);
    changedValue(newValues?.sale_status);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={saleStatusOptions}
      getOptionLabel={(option) => (option.name ? option.name : "")}
      isOptionEqualToValue={(option, selected) =>
        option.sale_status === selected.sale_status
      }
      renderInput={(params) => <TextField {...params} />}
      onChange={handleChange}
      value={value ?? null}
      sx={{ cursor: "pointer", pointerEvents: "auto" }}
    />
  );
}
